import { ComputedRef, computed } from 'vue'
import type { Store } from '@/store'

export function useError(store: Store): ComputedRef<string | null> {
  return computed(() => {
    const bookingError = store.getters['booking/getError']('fetchBookings')
    const liheError = store.getters['catalog/getError']('fetchLihes')

    if (liheError) {
      console.error(
        '%cLIHE ERROR: ' + liheError,
        'color: red; font-weight: bold;'
      )
    }

    return bookingError // Only show booking errors in the UI
  })
}
